var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAnchorLink = function SvgAnchorLink(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 25C12 25.5523 12.4477 26 13 26H37C37.5523 26 38 25.5523 38 25C38 24.4477 37.5523 24 37 24H13C12.4477 24 12 24.4477 12 25Z",
    fill: "#FC628F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47 16L31 16C29.3431 16 28 17.3431 28 19V22H30V19C30 18.4477 30.4477 18 31 18H47C47.5523 18 48 18.4477 48 19V31C48 31.5523 47.5523 32 47 32H31C30.4477 32 30 31.5523 30 31V28H28V31C28 32.6569 29.3431 34 31 34H47C48.6569 34 50 32.6569 50 31V19C50 17.3431 48.6569 16 47 16Z",
    fill: "#FC628F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 31C20 31.5523 19.5523 32 19 32H3C2.44772 32 2 31.5523 2 31L2 19C2 18.4477 2.44772 18 3 18H19C19.5523 18 20 18.4477 20 19V22H22V19C22 17.3431 20.6569 16 19 16L3 16C1.34315 16 0 17.3431 0 19L0 31C0 32.6569 1.34315 34 3 34H19C20.6569 34 22 32.6569 22 31V28H20V31Z",
    fill: "#FC628F"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAnchorLink);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/anchor-link.51e564a5260b43284b76623e24ce978a.svg";